import { requestBase } from '@/plugins/axios'

export default {
    // {page: 1,size: 10,}
    getList(params) {
      return requestBase({
        url: '/v1/factory/worker/working_time/all_worker',
        method: 'GET',
        params
      })
    },
    // {startTime,endtTime,role,workerId}
    getDetails(params) {
      return requestBase({
        url: '/v1/factory/worker/working_time',
        method: 'GET',
        params
      })
    }
}
